import script from "./WebVoiceAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./WebVoiceAgent.vue?vue&type=script&setup=true&lang=js"

import "./WebVoiceAgent.vue?vue&type=style&index=0&id=26a58be4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26a58be4"]])

export default __exports__